const isNewerSequence = (incoming, existing) => {
  const incomingStr = incoming.toString();
  const existingStr = existing.toString();

  const incomingTime = parseInt(incomingStr.slice(0, -3));
  const incomingCount = parseInt(incomingStr.slice(-3));

  const existingTime = parseInt(existingStr.slice(0, -3));
  const existingCount = parseInt(existingStr.slice(-3));

  if (incomingTime > existingTime) return true;
  if (incomingTime < existingTime) return false;

  return incomingCount > existingCount;
}

export default isNewerSequence;
